import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { bookingShape } from 'constants/propTypes';

import { Spinner } from 'admin-components/components';
import { GET_HISTORY } from 'store/queries';

import ReactPaginate from 'react-paginate';
import { useLazyQuery } from '@apollo/client';
import { HistoryDetail } from './HistoryDetail';
import { DetailsContainer } from './HistoryDetails.styles';
import { Column, Row } from 'components/shared/Layout';

const HistoryDetails = ({ booking, bookingReference }) => {
  const ITEMS_PER_PAGE = 20;

  const [pageOffset, setPageOffset] = useState(0);

  const [getHistory, { loading, data }] = useLazyQuery(GET_HISTORY, {
    fetchPolicy: 'network-only'
  });

  useEffect(() => {
    getHistory({
      variables: {
        bookingReference,
        page: pageOffset,
        size: ITEMS_PER_PAGE
      }
    });
  }, [bookingReference, getHistory, pageOffset]);

  const { details, totalCount } = data?.history || { details: [], totalCount: 0 };

  const detailsByRecentDate = [...details].sort((a, b) => new Date(b.date) - new Date(a.date));

  const pageCount = Math.ceil(totalCount / ITEMS_PER_PAGE);

  const handlePageChange = (event) => {
    setPageOffset(event.selected);
  };

  const renderReactPaginate = () => (
    <ReactPaginate
      data-cy="react-paginate"
      breakLabel="..."
      nextLabel=">"
      previousLabel="<"
      pageCount={pageCount}
      forcePage={pageOffset}
      pageRangeDisplayed={5}
      onPageChange={handlePageChange}
      renderOnZeroPageCount={null}
      breakClassName="page-item"
      breakLinkClassName="page-link"
      containerClassName="pagination"
      pageClassName="page-item"
      pageLinkClassName="page-link"
      previousClassName="page-item"
      previousLinkClassName="page-link"
      nextClassName="page-item"
      nextLinkClassName="page-link"
      activeClassName="active"
    />
  );

  if (loading) {
    return (
      <Row span={16} height="10vh" data-testid="full-page-spinner">
        <Column justifyContent="center" alignItems="center">
          <Spinner />
        </Column>
      </Row>
    );
  }

  return (
    <DetailsContainer data-cy="details-container">
      {renderReactPaginate()}

      {detailsByRecentDate.map((detail) => {
        const { customer: _, __typename: __, ...detailData } = detail?.data ?? {};

        if (Object.values(detailData).every((dataField) => dataField?.length === 0 || dataField === null)) {
          return null;
        }

        return <HistoryDetail key={detail.revisionNumber} booking={booking} detail={detail} />;
      })}

      {renderReactPaginate()}
    </DetailsContainer>
  );
};

HistoryDetails.propTypes = {
  booking: bookingShape,
  bookingReference: PropTypes.string.isRequired
};

export default HistoryDetails;
